import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReferralCode } from '../interfaces/data';
import { DataSelects, PostalCode } from '../interfaces/data-selects';

@Injectable({
  providedIn: 'root',
})
export class GetDataService {
  constructor(private http: HttpClient) {}
  getReferralCode(referralCode: string): Observable<ReferralCode> {
    return this.http.get<ReferralCode>(
      `${environment.apiurl}/api/v1.0/referral/${referralCode}`
    );
  }

  getSolicitudData(email: string, requestNumber: string): Observable<any> {
    return this.http.get(
      `${environment.apiurl}/api/v1.0/credit-application/${email}/${requestNumber}`
    );
  }

  ///////////////// NUEVO SERVICIOS DAE /////////////////////////////////
  //DATOS COMBOS (DAE MEXICO)//
  getApplicationsSelectsMx(countryCode: string): Observable<DataSelects> {
    return this.http.get<DataSelects>(
      `${environment.apiurl}/countries/${countryCode}/applications/data`
    );
  }

  ///CONSULTAR CODIGO POSTAL
  getPostalCode(countryCode: string, code: string): Observable<PostalCode> {
    return this.http.get<PostalCode>(
      `${environment.apiurl}/countries/${countryCode}/postal-codes/${code}`
    );
  }

  ////OBTENER DATOS A TRAVES DE TOKEN + CODIGO (BUSQUEDA)
  getUpdateDataTokenCode(
    email: string,
    token: string,
    code: string
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrlResume}/resume/${email}?token=${token}&code=${code}`
    );
  }

  //VISUALIZAR DOCUMENTO MX
  getViewDocuments(
    countryCode: string,
    applicationId: string,
    fileName: string
  ): Observable<any> {
    let fileNameBase64 = this.convertToBase64(fileName);

    return this.http
      .get(
        `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/documents/${fileNameBase64}`,
        {
          responseType: 'arraybuffer',
          observe: 'response',
        }
      )
      .pipe(
        map((doc) => {
          return new Blob([doc.body!], {
            type: doc.headers.get('content-type') || 'application/pdf',
          });
        })
      );
  }

  //DATOS COMBOS (DAE COLOMBIA)//
  getApplicationsSelectsCo(countryCode: string): Observable<DataSelects> {
    return this.http.get<DataSelects>(
      `${environment.apiUrlCo}/countries/${countryCode}/applications/data`
    );
  }

  //VISUALIZAR DOCUMENTO Co
  getViewDocumentsCo(
    countryCode: string,
    applicationId: string,
    fileName: string
  ): Observable<any> {
    let fileNameBase64 = this.convertToBase64(fileName);
    return this.http
      .get(
        `${environment.apiUrlCo}/countries/${countryCode}/applications/${applicationId}/documents/${fileNameBase64}`,
        {
          responseType: 'arraybuffer',
          observe: 'response',
        }
      )
      .pipe(
        map((doc) => {
          return new Blob([doc.body!], {
            type: doc.headers.get('content-type') || 'application/pdf',
          });
        })
      );
  }

  convertToBase64(text: string) {
    return btoa(
      encodeURIComponent(text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
      })
    );
  }

  //// NUEVOS SERVICIOS LTO ////
  getApplicationsSelectsLto(countryCode: string): Observable<DataSelects> {
    return this.http.get<DataSelects>(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/data`
    );
  }

  ///CONSULTAR CODIGO POSTAL
  getPostalCodeLtoMX(
    countryCode: string,
    code: string
  ): Observable<PostalCode> {
    return this.http.get<PostalCode>(
      `${environment.apiUrlLto}/countries/${countryCode}/postal-codes/${code}`
    );
  }

  //VISUALIZAR DOCUMENTO MX
  getViewDocumentsLto(
    countryCode: string,
    applicationId: string,
    fileName: string
  ): Observable<any> {
    let fileNameBase64 = this.convertToBase64(fileName);

    return this.http
      .get(
        `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/documents/${fileNameBase64}`,
        {
          responseType: 'arraybuffer',
          observe: 'response',
        }
      )
      .pipe(
        map((doc) => {
          return new Blob([doc.body!], {
            type: doc.headers.get('content-type') || 'application/pdf',
          });
        })
      );
  }

  getConsultLoginUberLto(
    countryCode: string,
    applicationId: string
  ): Observable<any> {
    return this.http.get(
      `${environment.apiUrlLto}/countries/${countryCode}/applications/${applicationId}/uber/has-logged`
    );
  }
  getConsultLoginUberDae(
    countryCode: string,
    applicationId: string
  ): Observable<any> {
    return this.http.get(
      `${environment.apiurl}/countries/${countryCode}/applications/${applicationId}/uber/has-logged`
    );
  }
}
